import { render, staticRenderFns } from "./urgentGoodsToPur.vue?vue&type=template&id=446be40a&scoped=true&"
import script from "./urgentGoodsToPur.vue?vue&type=script&lang=js&"
export * from "./urgentGoodsToPur.vue?vue&type=script&lang=js&"
import style0 from "./urgentGoodsToPur.vue?vue&type=style&index=0&id=446be40a&lang=less&scoped=true&"
import style1 from "./urgentGoodsToPur.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446be40a",
  null
  
)

component.options.__file = "urgentGoodsToPur.vue"
export default component.exports